import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tagManage",
  "use": "icon-tagManage-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-tagManage\"><path d=\"M216.177778 1001.244444H110.08c-28.444444 0-53.134222-22.983111-53.134222-55.523555V55.523556C56.888889 28.728889 79.644444 0 110.023111 0H216.177778v1001.244444z m692.906666 0H279.04V3.811556h323.470222v277.617777a22.755556 22.755556 0 0 0 39.992889 14.791111l30.549333-35.441777a34.133333 34.133333 0 0 1 51.086223-0.739556l32.483555 35.555556a22.755556 22.755556 0 0 0 39.594667-15.36V0h107.178667c28.444444 0 53.134222 22.983111 53.134222 55.523556v890.197333c5.688889 30.663111-17.066667 55.523556-47.445334 55.523555z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/tagManage.svg
// module id = IrbC
// module chunks = 78